import React from "react";

import { type UseFieldArrayAppend } from "react-hook-form";

import type z from "zod";

import { type DataColumn } from "../types";

import { type ClientSettingSchema } from "./client-setting-form";
import { GroupedDataColumnChooser } from "./generic/grouped-data-column-chooser";

type ClientSetting = z.infer<typeof ClientSettingSchema>;

type AppendSpendConstraintButtonProps = {
  append: UseFieldArrayAppend<ClientSetting, "spend_constraints">;
  availableDataColumns: DataColumn[];
  selectedDataColumnsIds: string[];
  previousPeriodSpendData: Record<string, number>;
};

export function AppendSpendConstraintButton({
  append,
  availableDataColumns,
  selectedDataColumnsIds,
  previousPeriodSpendData,
}: AppendSpendConstraintButtonProps) {
  return (
    <GroupedDataColumnChooser
      placement="top-start"
      onSelect={(id) =>
        append({
          data_column_id: id,
          budget_low: null,
          budget_high: null,
        })
      }
      availableDataColumns={availableDataColumns}
      selectedDataColumnsIds={selectedDataColumnsIds}
      buttonText="ADD REQUIREMENT"
      previousPeriodSpendData={previousPeriodSpendData}
    />
  );
}
